"use client";

import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical, Trash2, Check } from "lucide-react";
import { Input } from "src/components/ui/input";
import { Button } from "src/components/ui/button";
import { cn } from "src/lib/utils";

export default function SortableOption({
  option,
  onChange,
  onSelectCorrect,
  onRemove,
  disabled = false,
  language = "en",
  isSurvey = false,
  radioName, // Added radioName prop
}) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: option.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cn(
        "flex items-center gap-2 group border rounded-md p-2",
        !isSurvey && option.isCorrect && "border-green-300 bg-green-500/20"
      )}
    >
      <div
        {...attributes}
        {...listeners}
        className={cn("cursor-grab", disabled && "cursor-not-allowed")}
      >
        <GripVertical className="h-5 w-5 text-muted-foreground" />
      </div>
      <div className="flex-1 flex items-center gap-2">
        {!isSurvey && (
          <div className="flex items-center h-10 w-10 justify-center">
            <input
              type="radio"
              name={radioName} // Group radio buttons
              value={option.id}
              checked={option.isCorrect}
              onChange={() => onSelectCorrect(option.id)} // Pass option.id directly
              className="h-4 w-4"
              disabled={disabled}
            />
          </div>
        )}
        <Input
          value={option.text}
          onChange={(e) => onChange(e.target.value)}
          placeholder={
            language === "ar" ? "أدخل الخيار هنا" : "Enter option here"
          }
          className="flex-1 border"
          disabled={disabled}
        />
        <div className="flex items-center gap-2">
          {!isSurvey && option.isCorrect && (
            <span className="text-green-600 text-sm flex items-center whitespace-nowrap">
              <Check className="h-4 w-4 mr-1" />
              {language === "ar" ? "الإجابة الصحيحة" : "Correct Answer"}
            </span>
          )}
          <Button
            variant="ghost"
            size="icon"
            onClick={onRemove}
            className="h-8 w-8 opacity-0 group-hover:opacity-100 transition-opacity"
            disabled={disabled}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
